if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"infer_console_build_wa","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(default\-webpack_sharing_consume_default_angular_(co(mmon_angular_common|re_angular_core)|platform\-browser_angular_platform\-browser)|vendor)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}